import { SubscriptionResponseV1 } from '@/shared/api';
import { priceFormat } from '@/shared/utils';

const getBiggestPriceFromOneTimePaymentInfo = (
	oneTimePaymentInfo: SubscriptionResponseV1['oneTimePaymentInfo'],
) => {
	return (
		oneTimePaymentInfo.meta?.monthlyDiscountPrice ||
		oneTimePaymentInfo.discountPrice
	);
};

const getSmallerPriceFromOneTimePaymentInfo = (
	oneTimePaymentInfo: SubscriptionResponseV1['oneTimePaymentInfo'],
) => {
	return oneTimePaymentInfo.meta?.monthlyPrice || oneTimePaymentInfo.price;
};

type PreparePrices = {
	isShowDiscount: boolean;
	// стоимость продажи
	salePrice: string;
	// старая или обычная цена
	regularPrice: string;
	// скидка в рублях
	savePrice: string;
	// скидка в процентах
	savedPercent: number;
	// стоимость за месяц
	fromPerMonth: string;
};

export const preparePrices = (
	data: SubscriptionResponseV1,
	isPromoAllowed?: boolean,
): PreparePrices => {
	const isShowDiscount =
		(data.oneTimePaymentInfo.meta?.monthlyDiscountPrice &&
			data.oneTimePaymentInfo.meta?.monthlyDiscountPrice > 0) ||
		(data.oneTimePaymentInfo.discountPrice &&
			data.oneTimePaymentInfo.discountPrice > 0);

	const regularPrice = priceFormat({
		value: getSmallerPriceFromOneTimePaymentInfo(data.oneTimePaymentInfo),
		withCurrency: false,
	});

	let salePrice = regularPrice;
	let savePrice = '';
	let savedPercent = 0;
	let fromPerMonth = '';

	if (isPromoAllowed) {
		salePrice = priceFormat({
			value: isShowDiscount
				? data.oneTimePaymentInfo.discountPrice
				: data.oneTimePaymentInfo.price,
		});
	} else if (isShowDiscount) {
		salePrice = priceFormat({
			value: getBiggestPriceFromOneTimePaymentInfo(data.oneTimePaymentInfo),
			withCurrency: false,
		});

		savePrice = priceFormat({
			value: getSmallerPriceFromOneTimePaymentInfo(data.oneTimePaymentInfo),
			withCurrency: false,
		});

		savedPercent = Math.round(
			((getSmallerPriceFromOneTimePaymentInfo(data.oneTimePaymentInfo) -
				getBiggestPriceFromOneTimePaymentInfo(data.oneTimePaymentInfo)) /
				getSmallerPriceFromOneTimePaymentInfo(data.oneTimePaymentInfo)) *
				100,
		);
	}

	if (
		data.loanPaymentInfo.startingFromPerMonth > 0 &&
		data.loanPaymentInfo.enabled
	) {
		fromPerMonth = priceFormat({
			value: data.loanPaymentInfo.startingFromPerMonth,
			withCurrency: false,
		});
	}

	return {
		isShowDiscount: !!isShowDiscount,
		regularPrice,
		salePrice,
		savePrice,
		savedPercent,
		fromPerMonth,
	};
};
